import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { timestampFormatter } from '@retainerclub/common';
import { useAccount } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import RetainerWizardNoBankSubscriptions from './RetainerWizardNoBankSubscriptions';

function RetainerWizardNoBank({
  patient,
  handleCloseModal,
  handleOpenManageSubscription,
}) {
  const { setCurrentPatient } = useAccount();
  const navigate = useNavigate();

  const activeSubscription = patient?.subscriptions?.find(
    (sub) => sub.state === 'active',
  );

  function handleShop() {
    setCurrentPatient(patient);
    navigate('/shop');
  }

  function handleManageClick() {
    if (handleOpenManageSubscription && activeSubscription) {
      handleCloseModal();
      handleOpenManageSubscription({
        ...activeSubscription,
        patient,
      });
    }
  }

  return (
    <div className="isolate overflow-hidden">
      <div className="flow-root bg-gray-900 pt-8 pb-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          {activeSubscription && (
            <div className="relative z-10 mx-auto mb-6 max-w-4xl rounded-lg border-2 border-blue-400 bg-blue-50 p-4">
              <div className="flex gap-3">
                <InformationCircleIcon className="h-6 w-6 shrink-0 text-blue-600" />
                <div className="flex-1">
                  <h3 className="font-semibold text-blue-900 text-sm">
                    You have an active subscription
                  </h3>
                  <p className="mt-2 text-blue-800 text-sm">
                    <strong>{activeSubscription.name}</strong> - Renewing on{' '}
                    {timestampFormatter(activeSubscription.renewalAt, false)}
                  </p>
                  <p className="mt-2 text-blue-700 text-xs">
                    This area is for ordering retainers immediately. If you want
                    to manage your subscription plan, click below:
                  </p>
                  <button
                    type="button"
                    onClick={handleManageClick}
                    className="mt-3 rounded-md bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700"
                  >
                    Manage My Subscription
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="relative z-10">
            <h2 className="mx-auto max-w-4xl text-center font-bold text-5xl text-white tracking-tight">
              Right Retainer. Right Time
              <span className="align-super text-xl">&#8482;</span>
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-white/60 leading-6">
              You have options! Choose to start an annual replacement plan with
              Member Pricing or purchase a single set of retainers by clicking
              the button below.
            </p>
            <div className="mt-4 flex items-center">
              <button
                type="button"
                onClick={handleShop}
                className="mx-auto rounded-full border border-rcprimary-400 px-2.5 py-1 text-rcprimary-400 text-sm hover:border-white/80 hover:text-white/80 focus-visible:outline-rcprimary-400 focus-visible:ring-1 focus-visible:ring-rcprimary-400/50"
              >
                Shop Other Options
              </button>
            </div>
          </div>
          <div className="relative mx-auto mt-6 grid max-w-md grid-cols-1 gap-y-8 lg:mx-0 lg:-mb-14 lg:max-w-none lg:grid-cols-3">
            <svg
              viewBox="0 0 1208 1024"
              aria-hidden="true"
              className="mask-[radial-gradient(closest-side,white,transparent)] absolute -bottom-48 left-1/2 h-256 -translate-x-1/2 translate-y-1/2 lg:-top-48 lg:bottom-auto lg:translate-y-0"
            >
              <ellipse
                cx={604}
                cy={512}
                fill="url(#d25c25d4-6d43-4bf9-b9ac-1842a30a4867)"
                rx={604}
                ry={512}
              />
              <defs>
                <radialGradient id="d25c25d4-6d43-4bf9-b9ac-1842a30a4867">
                  <stop stopColor="#37b87b" />
                  <stop offset={1} stopColor="#d4f7e1" />
                </radialGradient>
              </defs>
            </svg>
            <div
              className="hidden lg:absolute lg:inset-x-px lg:top-4 lg:bottom-0 lg:block lg:rounded-t-2xl lg:bg-gray-800/80 lg:ring-1 lg:ring-white/10"
              aria-hidden="true"
            />

            <RetainerWizardNoBankSubscriptions
              patient={patient}
              handleCloseModal={handleCloseModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

RetainerWizardNoBank.propTypes = {
  patient: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleOpenManageSubscription: PropTypes.func,
};

export default RetainerWizardNoBank;
